export default __webpack_public_path__ + "static/media/066-canada.6cef5fe9.svg";